import type {CSSProperties} from 'react';
import {WEDGE_SHELL as B, WEDGE_NOTICE as N} from '@territory/tokens';
import {font, radius, space, weight} from '../scale.js';

export type WedgeNoticeLook = 'in-app-open' | 'in-app-copy' | 'verify-dismiss' | 'update';
/* Released native notice geometry. The dismiss target remains 32px; in-app controls omit a minimum height. */
const DISMISS_MIN = 32;
const NOTICE_PY = 10;
const UPDATE_TRACK = 0.2;
export function wedgeNoticeStyle(look: WedgeNoticeLook): CSSProperties {
  if (look === 'verify-dismiss') return {
    background: 'none', border: 0, cursor: 'pointer', padding: 0,
    minWidth: DISMISS_MIN, minHeight: DISMISS_MIN, color: B.text,
    fontSize: font.title2, lineHeight: 1, fontFamily: 'inherit', opacity: 0.8,
  };
  if (look === 'update') return {
    border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
    gap: NOTICE_PY, width: '100%', padding: 'calc(10px + env(safe-area-inset-top)) 16px 10px',
    background: B.accent, color: B.accentInk, fontFamily: B.fontBody,
    fontSize: font.footnote, fontWeight: weight.bold, letterSpacing: UPDATE_TRACK, textAlign: 'center',
    /* Both released fixed banners use this exact shadow. */
    boxShadow: N.offlineShadow,
  };
  const copy = look === 'in-app-copy';
  return {
    padding: `${NOTICE_PY}px ${space[3]}px`, borderRadius: radius.md,
    border: copy ? `1px solid ${B.warningControlBorder}` : 0,
    background: copy ? 'transparent' : B.amber, color: copy ? B.warningControlInk : B.warningControlDarkInk,
    fontSize: font.footnote, fontWeight: weight.bold, cursor: 'pointer', fontFamily: 'inherit',
  };
}
